"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarleyItem = void 0;
var Token_1 = require("./Token");
var NextId = 0;
/** @constructor */
var EarleyItem = /** @class */ (function () {
    function EarleyItem(rule, pos, base, token, prev, location) {
        this.rule = rule;
        this.pos = pos;
        this.base = base;
        this.token = token;
        this.prev = prev;
        this.location = location;
        this.id = NextId++;
    }
    EarleyItem.prototype.toString = function () {
        var str = '[' + this.id + '] ' + this.rule.name + ':';
        for (var i = 0; i < this.rule.symbols.length; i++) {
            if (i == this.pos) {
                str += ' .';
            }
            str += ' ' + this.rule.symbols[i];
        }
        if (i == this.pos) {
            str += ' .';
        }
        str += ', ' + this.base;
        if (this.token instanceof Token_1.Token) {
            str += ', token=' + this.token.text;
        }
        else if (this.token) {
            str += ', rule=' + this.token.rule;
        }
        if (this.prev) {
            str += ', prev=' + this.prev.id;
        }
        return str;
    };
    return EarleyItem;
}());
exports.EarleyItem = EarleyItem;
//# sourceMappingURL=EarleyItem.js.map